import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export default /*@__PURE__*/Object.assign({
  inheritAttrs: false
}, {
  __name: 'AlertBar',
  props: {
    content: {
      type: String,
      default: undefined
    },
    type: {
      type: String,
      default: 'warning'
    },
    variant: {
      type: String,
      default: 'tonal'
    },
    density: {
      type: String,
      default: 'compact'
    }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      const _component_v_alert = _resolveComponent("v-alert");
      return _openBlock(), _createBlock(_component_v_alert, _mergeProps({
        type: __props.type,
        variant: __props.variant,
        density: __props.density
      }, _ctx.$attrs), {
        default: _withCtx(() => [_renderSlot(_ctx.$slots, "default", {}, () => [_createTextVNode(_toDisplayString(__props.content), 1)])]),
        _: 3
      }, 16, ["type", "variant", "density"]);
    };
  }
});